/** DEV ONLY. Logs the request instead of reaching a store, so the game's pacing can be watched in a browser. */
import type { ReviewProvider } from './types.js';

export class DevReviewProvider implements ReviewProvider {
  readonly kind = 'dev';
  readonly available = true;
  /** requests so far (tests) */
  requests = 0;

  constructor(private readonly log: (msg: string) => void = (m) => console.info(`[review:dev] ${m}`)) {}

  async request(): Promise<void> {
    this.requests++;
    this.log('review requested');
  }
}
